module.exports = __webpack_public_path__ + "img/A2.4cb3fabb.png";